import React from "react"

export default function Share() {
   return (
      <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
         <path d="M9.25084 7.11841C12.6533 7.11841 15.9995 9.14341 15.9995 14.9934C14.228 12.1247 11.9503 11.6184 9.25084 11.6184V13.2852C9.25084 13.9635 8.45968 14.334 7.93863 13.8997L3.42378 10.1366C2.94412 9.73678 2.94412 9.00004 3.42378 8.60025L7.93863 4.83713C8.45968 4.40284 9.25084 4.77335 9.25084 5.45166V7.11841Z" fill="#5B5E71" />
      </svg>
   )
}
